module.exports = __webpack_public_path__ + "media/images/e_pidtrymka_white-48e03148a2a8c4f0141c78574e3f30b2.svg";